<div class="wrapper custom-loader" *ngIf="loading">
  <div class="lds-dual-ring"></div>
</div>
